<template>
    <div class="wrapper" :class="{ 'wrapper--details': details }">
        <v-card rounded class="inventory-status">
            <v-row justify="center" no-gutters>
                <template v-for="(item, index) in items">
                    <v-col v-if="index != 0" :key="`divider-${index}`" cols="auto" class="d-none d-md-block">
                        <div class="h-100 py-18px py-md-24px">
                            <v-divider vertical />
                        </div>
                    </v-col>
                    <v-col :key="item.text" cols="4" md="">
                        <v-card v-bind="{ loading }" tile color="transparent" loader-height="100%" class="py-18px py-md-24px">
                            <div class="d-flex flex-column align-center">
                                <v-avatar :size="$vuetify.breakpoint.mobileBreakpoint ? '60' : '40'" color="white" class="mb-8px mb-12px">
                                    <v-img :src="item.icon" max-width="36" height="auto" alt="" class="rounded-0" />
                                </v-avatar>
                                <div class="font-size-14 font-size-md-16 font-weight-medium line-height-1 grey--text text--darken-4">{{ item.text }}</div>
                                <div class="font-size-20 font-size-lg-28 font-weight-bold grey--text text--darken-4 mt-8px mt-md-12px">{{ item.value }}</div>
                            </div>
                        </v-card>
                    </v-col>
                </template>
            </v-row>
        </v-card>
        <slot />
    </div>
</template>

<script>
import api from "@/api";

export default {
    props: {
        details: { type: Boolean, default: false },
    },
    data: () => ({
        loading: false,

        data: {
            currentStock: undefined,
            currentStout: undefined,
            entireAmount: 0,
            overallPrice: 0,
            productCount: 0,
        },
    }),
    computed: {
        items() {
            return [
                {
                    text: "총 보유 상품수",
                    icon: "/images/icon/icon-list.svg",
                    value: this.data.productCount?.format?.(),
                },
                {
                    text: "총 재고 수량",
                    icon: "/images/icon/icon-stock.svg",
                    value: this.data.entireAmount?.format?.(),
                },
                {
                    text: "총 재고 자산가치",
                    icon: "/images/icon/icon-value.svg",
                    value: this.data.overallPrice?.format?.(),
                },
                {
                    text: "최근입고일",
                    icon: "/images/icon/icon-receiving.svg",
                    value: this.data.currentStock ? this.$dayjs(this.data.currentStock).format("YYYY.M.D") : "-",
                },
                {
                    text: "최근 출고일",
                    icon: "/images/icon/icon-shipping.svg",
                    value: this.data.currentStout ? this.$dayjs(this.data.currentStout).format("YYYY.M.D") : "-",
                },
            ];
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let data = await api.v1.me.stocks.dashboard.get();
                this.data = data;
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    .inventory-status {
        background-color: var(--v-grey-lighten5);
    }
    &--details {
        .inventory-status {
            border-bottom-left-radius: 0 !important;
            border-bottom-right-radius: 0 !important;
        }
    }
}
</style>
